<template>
  <div :id="id" class="accordion">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
};
</script>
